import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledOrderInvoiceBase = styled('div')`
  background-color: ${(props) => props.theme.filterBackground};
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 9px;
  border: 1px solid ${(props) => props.theme.borderTable};

  .divider {
    display: flex;
    justify-content: center;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 20px 20px 20px;
    text-decoration: underline;

    .arrange-delivery {
      cursor: pointer;
    }
  }

  .invoice-data {
    display: flex;
    justify-content: space-between;
    padding: 20px;

    .first {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .field {
        display: flex;

        .label {
          color: ${(props) => props.theme.stepInactiveColor};
          font-size: 14px;
          text-wrap: nowrap;
          min-width: 150px;
        }
        .value {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }

    .second {
      width: 27%;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .field {
        display: flex;
        justify-content: space-between;

        .label {
          color: ${(props) => props.theme.stepInactiveColor};
          font-size: 14px;
          text-wrap: nowrap;
        }
        .value {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .divider {
      display: none;
    }

    .invoice-data {
      flex-direction: column;
      padding: 10px;

      .first {
        width: 100%;
        border-bottom: 1px solid ${(props) => props.theme.borderTable};
        padding-bottom: 10px;
        margin-bottom: 10px;
        .field {
          justify-content: space-between;
          .value {
            text-align: end;
          }
        }
      }
      .second {
        width: 100%;
        .field {
          .value {
            text-align: end;
          }
        }
      }
    }
    .footer {
      padding: 0 10px 10px 10px;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .invoice-data {
      .first {
        .field {
          .label {
            min-width: 110px;
          }
        }
      }
    }
  }
`;
